<template>
    <form-dialog :value="value" @input="$emit('input', $event)">
        <template #activator="bindings">
            <slot name="activator" v-bind="bindings"></slot>
        </template>
        <template #default="{ close }">
            <delete-cloud-account-card
                :loading="$wait.is('deleteAccount')"
                :value="account"
                :title="$t('deleteCloudAccountDialog.title')"
                :subtitle="$t('deleteCloudAccountDialog.subtitle')"
            >
                <template #actions="{ isValid, formId, clear }">
                    <back-button @click="close()"></back-button>
                    <v-spacer></v-spacer>
                    <delete-cloud-account-button
                        :value="account"
                        :clear="clear"
                        :valid="isValid"
                        :form="formId"
                        v-wait-while="'deleteAccount'"
                        @http2xx="close().then(() => $emit('http2xx', $event))"
                    ></delete-cloud-account-button>
                </template>
            </delete-cloud-account-card>
        </template>
    </form-dialog>
</template>

<i18n>
{
    "en": {
        "deleteCloudAccountDialog.title": "Delete Cloud Connection",
        "deleteCloudAccountDialog.subtitle": "Warning: This process is irreversible! Your cloud connection data will be deleted permanently and you will need to re-enter your credentials if you want to see your data again."
    }
}
</i18n>

<script>
import DeleteCloudAccountCard from '@/components/Common/DeleteEntityCard';
import DeleteCloudAccountButton from '@/components/Settings.CloudAccounts/DeleteCloudAccountButton.vue';
export default {
    components: { DeleteCloudAccountCard, DeleteCloudAccountButton },
    props: {
        value: Boolean,
        account: Object,
    },
};
</script>